// extracted by mini-css-extract-plugin
export default {"container":"PatientsPage_container__vMvmZ","link":"PatientsPage_link__SkoEb"};